import styles from 'assets/jss/material-dashboard-pro-react/customSelectStyle';
import stylesSearch from 'assets/jss/material-dashboard-pro-react/components/searchBoxStyle';
import customCheckboxRadioSwitch from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch';
import {
	blackColor,
	hexToRgb,
} from 'assets/jss/material-dashboard-pro-react.js';

const reactTableStyle = {
	...styles,
	...stylesSearch,
	...customCheckboxRadioSwitch,
	formControlMargins: {
		margin: '15px 0 !important',
	},
	gridContainer: {
		justifyContent: 'center',
	},
	labelHorizontal: {
		color: 'rgba(' + hexToRgb(blackColor) + ', 0.7)',
		cursor: 'pointer',
		display: 'inline-flex',
		fontSize: '14px',
		lineHeight: '1.428571429',
		fontWeight: '400',
		paddingTop: '25px',
		marginRight: '0',
		'@media (min-width: 992px)': {
			float: 'right',
		},
	},
	headerPanel: {
		display: 'flex',
		flexWrap: 'wrap',
    alignItems: 'center',
		paddingBottom: '8px',
		justifyContent: 'flex-end',
	},
	labelCounter: {
		color: 'rgba(' + hexToRgb(blackColor) + ', 0.7)',
		cursor: 'pointer',
		display: 'inline-flex',
		fontSize: '14px',
		lineHeight: '1.428571429',
		fontWeight: '400',
		paddingTop: '17px',
		marginRight: '0',
		marginLeft: '5rem',
	},
	tableHeader: {
		color: 'rgba(' + hexToRgb(blackColor) + ', 0.7)',
		display: 'inline-flex',
		paddingTop: '20px',
		fontSize: '18px',
		fontWeight: 'lighter',
		'&.withCardIcon': {
			marginRight: '0',
			marginLeft: '5rem',
		},
	},
	searchContainer: {
		position: 'absolute',
		top: '-4rem',
		zIndex: '20',
	},
	svgContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: 'inherit',
	},
	searchInput: {
		marginLeft: '40px',
	},
	right: {
		float: 'right',
	},
	buttonRight: {
		paddingLeft: '0',
	},
	top: {
		paddingTop: '10px',
	},
	rowsPerPageContainer: {
		paddingLeft: '2px !important',
		paddingRight: '2px !important',
	},
	rowsPerPageControl: {
		margin: '0 !important',
	},
	labelCentered: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: 'inherit',
		backgroundColor: '#F9F9F9',
		fontSize: '14px',
	},
	tableContainer: {
		minHeight: '398px',
		'&.nestedTable': {
			minHeight: '240px',
		}
	},
};

export default reactTableStyle;
